export enum EOpenPoseCursorPlane {
  NONE = '',

  XY = 'XY_PLANE',
  XZ = 'XZ_PLANE',
  YZ = 'YZ_PLANE',
}
